// extracted by mini-css-extract-plugin
module.exports = {"ActivityCounts":"styles_ActivityCounts__WSONf","total":"styles_total__2gPtM","icons":"styles_icons__2D8ow"};